import { Link } from "react-router-dom";
import type { MangaWork } from "@/mocks/manga";

export default function MangaCard({ work }: { work: MangaWork }) {
  return (
    <Link
      to={`/work/${work.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/60 bg-background-200/40 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={work.cover}
          alt={`${work.title} 雪景漫画封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-transparent to-background-950/10"></div>
        <span className="absolute left-2 top-2 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-foreground-950 backdrop-blur-sm">
          <i className="ri-star-fill text-primary-500"></i>
          {work.rating.toFixed(1)}
        </span>
        <span
          className={`absolute right-2 top-2 inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs ${
            work.status === "连载中"
              ? "bg-accent-500 text-background-950"
              : "bg-secondary-500 text-background-950"
          }`}
        >
          {work.status}
        </span>
        <span className="absolute bottom-2 left-2 right-2 inline-flex items-center gap-1.5 truncate rounded-md bg-background-950/60 px-2.5 py-1.5 text-xs text-foreground-300 backdrop-blur-sm">
          <i className="ri-book-open-line text-primary-500"></i>
          {work.latestChapter}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-500">
          {work.title}
        </h3>
        <p className="mt-1.5 flex items-center justify-between text-xs text-foreground-600">
          <span className="inline-flex items-center gap-1"><i className="ri-price-tag-3-line text-primary-500"></i>{work.categoryName}</span>
          <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{work.views}</span>
        </p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {work.tags.slice(0, 3).map((t) => (
            <span key={t} className="whitespace-nowrap rounded-full bg-secondary-100/60 px-2 py-0.5 text-[11px] text-foreground-700">
              {t}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}